module.exports = __webpack_public_path__ + "static/media/1 41 fullt.229501e9.mp3";